export default __webpack_public_path__ + "static/Popo@2x-9badada68308f2f0e209d76912e1f8be.png";